"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_number_format_1 = require("react-number-format");
const SelectModal_1 = __importDefault(require("../SelectModal"));
const Label_1 = __importDefault(require("../Label/Label"));
const styled_1 = require("./styled");
/**
 * Input element with optional action label
 */
const InputNumber = (_a) => {
    var { action, error, placeholder = '0', value, onChange, disabled = false, prefix, selectModal, details, mobileDetails, subtext } = _a, rest = __rest(_a, ["action", "error", "placeholder", "value", "onChange", "disabled", "prefix", "selectModal", "details", "mobileDetails", "subtext"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.InputWrapper, { error: typeof error !== 'undefined', disabled: disabled, hasDropdown: !!selectModal },
            react_1.default.createElement(styled_1.CharacterWrapper, { hasSubtext: !!subtext },
                react_1.default.createElement(react_number_format_1.NumericFormat, Object.assign({ placeholder: placeholder, prefix: prefix, value: value, onChange: onChange, disabled: disabled, displayType: "input" }, rest)),
                !!subtext && react_1.default.createElement(Label_1.default, { small: true }, subtext)),
            action && react_1.default.createElement(styled_1.ActionWrapper, null, action),
            selectModal && (react_1.default.createElement(SelectModal_1.default, Object.assign({ id: "input-dropdown", disabled: disabled }, selectModal))),
            details && !error && (react_1.default.createElement(styled_1.DetailsMessage, { disabled: disabled }, details)),
            mobileDetails && !details && !error && (react_1.default.createElement(styled_1.MobileDetailsMessage, { disabled: disabled }, mobileDetails)),
            error && react_1.default.createElement(styled_1.ErrorMessage, null, error))));
};
exports.default = InputNumber;
//# sourceMappingURL=InputNumber.js.map